import React, { useEffect } from "react";
import styled from "styled-components";
import { colors } from "../../theme/color";

const ModalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  position: fixed;
  width: 27rem;
  height: auto;
  top: 20%;
  left: 80%;
  transform: translate(-50%, -50%);
  background-color: #def1de;
  border-radius: 10px;
  padding: 1rem;
  z-index: 9999;
  line-height: 24px;
  letter-spacing: 2%;
  @media (max-width: 850px) {
    width: 18.375rem;
    height: auto;
    top: 20%;
    left: 70%;
    padding: 1rem;
  }
`;

const Circle = styled.div`
  width: 34px;
  height: 34px;
  background-color: #ffffff;
  border-radius: 50%;
  border: 2px solid ${colors.ButtonBackgroundColors}; /* Green border */
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1rem;
  margin-top: 1.4rem;
  @media (max-width: 850px) {
    width: 65px;
    height: 30px;
    margin-top: 2.2rem;
  }
`;

const Checkmark = styled.span`
  color: #00a602;
  width: 13.28px;
  border: 1.42px;
`;

const Message = styled.p`
  text-align: left;
  weight: 400;
  font-size: 1rem;
  color: #388233;
  @media (max-width: 850px) {
    text-align: left;
  }
`;

interface ModalProps {
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ onClose }) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest("#modal-container")) {
        onClose();
      }
    };
    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, [onClose]);

  return (
    <ModalContainer id="modal-container">
      <Circle>
        <Checkmark>✓</Checkmark>
      </Circle>
      <Message>
        We've received your message. We'll get back to you as soon as possible.
      </Message>
    </ModalContainer>
  );
};

export default Modal;
